import URL from '../api_url';

export const LOCAL_FILE_PATIENT_API = `${URL}/local-file`;

export const LOCAL_FILE_PATIENTS_API = `${URL}/local-files`;
